/**
 * helper function to get current project based on the route param 'projectId'
 */
import { watch, ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useProjectStore } from "@/stores";
import { type Project } from "@/types/types";

export function useCurrentProject() {
    const route = useRoute();
    const projects = useProjectStore();
   // const shortlistStore = useShortlistStore();
   // const currentProject = ref<Project>();
    const error = ref<Error | null>(null);
    const loading = ref<boolean>(false);

    
    //TODO this was teken from the project.vue:   
    // watch the params of the route to fetch the data again
  //  watch(() => route.params.projectId, fetchData, { immediate: true });

 /*   function fetchData(){
        console.log("Current-project running fetchData...");
        loading.value = true;
        currentProject.value = {projectName : 'empty' };
        error.value = null;
        const projectId = route.params.projectId;
        console.log("...projectId from route  = " + projectId);

        try{

            currentProject.value = projects.getById(route.params.projectId);
            //await projectStore.setCurrentProject(route.params.projectId)
            shortlistStore.add(route.params.projectId);
        }catch(err){
            error.value = err.toString();
        }finally{
            loading.value = false;
        }
        console.log("..Current-project fetchData() returning...");
        console.log(".currentProject " + JSON.stringify(currentProject.value));
        console.log("currentProject.id = " + currentProject.value.id);
        
    }*/

    //try with computed
    const currentProject = computed<Project>(()=>{
        loading.value = true;
        error.value = null;
        let proj;
        try{
            proj = projects.getById(route.params.projectId);
            //await projectStore.setCurrentProject(route.params.projectId)
           // shortlistStore.add(route.params.projectId);
        }catch(err){
            console.log("...currentProject computed error..." + err);
            error.value = err.toString();
            proj = null;
        }finally{
            loading.value = false;
        }
        return proj;
    })

    return {
        currentProject,
        loading,
        error
    }

}